/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Meta_DescriptionInputs */

const en_gc_editor_meta_description = /** @type {(inputs: Gc_Editor_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use GridCraft online: launch ArtCraft’s open-source XLSX spreadsheet editor, choose a sales, budget or grade sample, and save your workbook locally.`)
};

const zh_gc_editor_meta_description = /** @type {(inputs: Gc_Editor_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线使用 GridCraft：启动 ArtCraft 开源 XLSX 电子表格编辑器，选择销售、预算或成绩示例，并在本地保存工作簿。`)
};

/**
* | output |
* | --- |
* | "Use GridCraft online: launch ArtCraft’s open-source XLSX spreadsheet editor, choose a sales, budget or grade sample, and save your workbook locally." |
*
* @param {Gc_Editor_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_meta_description = /** @type {((inputs?: Gc_Editor_Meta_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Meta_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_meta_description(inputs)
	return zh_gc_editor_meta_description(inputs)
});
export { gc_editor_meta_description as "gc.editor.meta_description" }